/**
 * Created by Mark on 24/11/2016.
 */


import LicenceStore from './store/licence-store.js'
import UserStore from './store/user-store.js'
let exportClass = class UpdateAction {

    update(action , data){
        LicenceStore.import(action, data);
        UserStore.import(action, data);
    }
}

export default  new exportClass();